import {Component, Input} from "@angular/core";
import {CONDITION_TYPES_LIST} from "../../enums/e-conditions";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {ICondition} from "../../interfaces/condition.definition";


@Component({
  selector: "nv-conditions",
  templateUrl: "./nv-conditions.component.html"
})
export class NvConditionsComponent {
  private _title: string;
  private _document: any;
  private _pointer: string;
  private _selected: ICondition;

  @Input() set document(v: any) { this._document = v; };
  @Input() set title(v: string) { this._title = v; }
  @Input() set pointer(v: string) { this._pointer = v; }

  get document() { return this._document; }
  get pointer() { return this._pointer; }
  get title(): string { return this._title || "NO TITLE"; }
  get selected(): ICondition { return this._selected; }
  get conditions(): ICondition[] { return JP.get(this.document, this.pointer); }


  constructor(private factoryService: FactoryService) {
  }


  getItemLabel(item: ICondition): string {
    // todo: use dict to improve search performance
    for (let i = 0; i < CONDITION_TYPES_LIST.length; ++i) {
      let r = CONDITION_TYPES_LIST[i];
      if (r.id === item.type) {
        return r.label;
      }
    }
    return `invalid cond ${item.type}`;
  }


  onItemSelected(item: ICondition): void {
    this._selected = item;
  }


  onAddClick(): void {
    this.factoryService.pushNewConditionTo(this.document, this.pointer);
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-condition/nv-conditions.component.ts